(() => {
  const glow = document.querySelector('[data-md-glow]');
  if (!glow) return;
  document.documentElement.classList.add('md-has-glow');
  const blobs = [...glow.querySelectorAll('[data-md-glow-blob]')];
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const paths = [
    [[0.72, 0.38], [0.3, 0.55], [0.78, 0.62], [0.22, 0.35], [0.65, 0.5]],
    [[0.18, 0.7], [0.75, 0.3], [0.35, 0.75], [0.8, 0.45], [0.3, 0.6]]
  ];
  const state = blobs.map(() => ({ x: 0, y: 0, tx: 0, ty: 0 }));

  const target = (time) => {
    const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    const progress = Math.min(1, Math.max(0, scrollY / max));
    blobs.forEach((blob, i) => {
      const path = paths[i % paths.length];
      const span = progress * (path.length - 1);
      const index = Math.min(path.length - 2, Math.floor(span));
      const t = span - index;
      const ease = t * t * (3 - 2 * t);
      const [x1, y1] = path[index];
      const [x2, y2] = path[index + 1];
      const wobble = still ? 0 : Math.sin(time / (5200 + i * 1700) + i * 2) * 0.05;
      state[i].tx = (x1 + (x2 - x1) * ease + wobble) * innerWidth;
      state[i].ty = (y1 + (y2 - y1) * ease + Math.cos(time / (6100 + i * 1300)) * (still ? 0 : 0.04)) * innerHeight;
    });
  };

  let first = true;
  const tick = (time) => {
    target(time || 0);
    state.forEach((s, i) => {
      const k = first || still ? 1 : 0.035;
      s.x += (s.tx - s.x) * k;
      s.y += (s.ty - s.y) * k;
      blobs[i].style.setProperty('--_x', `${s.x.toFixed(1)}px`);
      blobs[i].style.setProperty('--_y', `${s.y.toFixed(1)}px`);
    });
    first = false;
    if (!still && !document.hidden) requestAnimationFrame(tick);
  };

  if (still) {
    tick(0);
    addEventListener('scroll', () => requestAnimationFrame(tick), { passive: true });
  } else {
    requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) requestAnimationFrame(tick);
    });
  }
})();
